import { CartLinesUpdateEvent } from '@shopify/events';
let pending = false;
const pendingNotices = new Map();

function quickItems(form) {
  const data = new FormData(form);
  const indexed = new Map();
  for (const [name, value] of data.entries()) {
    const match = name.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
    if (!match) continue;
    const index = Number(match[1]);
    const item = indexed.get(index) || {};
    item[match[2]] = value;
    indexed.set(index, item);
  }
  const ids = data.getAll('id');
  const quantities = data.getAll('quantity');
  if (indexed.size && ids.length) throw new Error(form.dataset.avInvalidMessage || document.documentElement.dataset.avCartError);
  if (!indexed.size && quantities.length > 1 && quantities.length !== ids.length) throw new Error(form.dataset.avInvalidMessage || document.documentElement.dataset.avCartError);
  const raw = indexed.size
    ? [...indexed.entries()].sort(([a], [b]) => a - b).map(([, item]) => item)
    : ids.map((id, index) => ({ id, quantity: quantities.length > 1 ? quantities[index] : quantities[0] ?? 1 }));
  if (!raw.length) throw new Error(form.dataset.avInvalidMessage || document.documentElement.dataset.avCartError);
  const items = new Map();
  for (const item of raw) {
    const id = Number(item.id);
    const quantity = Number(item.quantity ?? 1);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) throw new Error(form.dataset.avInvalidMessage || document.documentElement.dataset.avCartError);
    const combined = (items.get(id)?.quantity || 0) + quantity;
    if (!Number.isSafeInteger(combined)) throw new Error(form.dataset.avInvalidMessage || document.documentElement.dataset.avCartError);
    items.set(id, { id, quantity: combined });
  }
  return [...items.values()];
}
document.addEventListener('submit', async (event) => {
  const form = event.target.closest?.('[data-av-quick]');
  if (!form) return;
  event.preventDefault();
  const status = form.closest('[data-av-commerce], .av-complements')?.querySelector('[data-av-quick-status]');
  if (pending) {
    if (status && form.dataset.avBusyMessage) {
      status.textContent = form.dataset.avBusyMessage;
      pendingNotices.set(status, form.dataset.avBusyMessage);
    }
    return;
  }
  const button = form.querySelector('button[type="submit"], button:not([type])');
  if (!button || button.disabled) return;
  let items;
  try {
    items = quickItems(form);
  } catch (error) {
    if (status) status.textContent = error.message || document.documentElement.dataset.avCartError;
    return;
  }
  pending = true;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (status) status.textContent = '';
  const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))];
  const deferred = CartLinesUpdateEvent.createPromise();
  const itemCount = items.reduce((total, item) => total + item.quantity, 0);
  const root = window.Shopify.routes.root;
  const refreshCart = async () => {
    const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error(document.documentElement.dataset.avCartError);
    return response.json();
  };
  form.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: items.map(item => ({merchandiseId: String(item.id), quantity: item.quantity})), promise: deferred.promise}));
  try {
    const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items, sections: sectionIds, sections_url: window.location.pathname})});
    const added = await response.json();
    if (!response.ok || added.status) throw new Error(added.description || added.message || document.documentElement.dataset.avCartError);
    let cart;
    try {
      cart = await refreshCart();
    } catch (error) {
      deferred.reject(error);
      window.location.href = root + 'cart';
      return;
    }
    deferred.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {items: cart.items, source: 'av-quick-form', sections: added.sections, itemCount, didError: false}});
    if (!document.querySelector('theme-drawer#cart-drawer')) window.location.href = root + 'cart';
  } catch (error) {
    try {
      const cart = await refreshCart();
      deferred.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {items: cart.items, source: 'av-quick-form', itemCount, didError: true}});
    } catch {
      deferred.reject(error);
    }
    if (status) status.textContent = error.message || document.documentElement.dataset.avCartError;
  } finally {
    pending = false;
    for (const [notice, message] of pendingNotices) {
      if (notice.textContent === message) notice.textContent = '';
    }
    pendingNotices.clear();
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});

